import { useState } from 'react';
import styled from 'styled-components';
import { OfferHistory } from '../../../../components/Offers';
import { Tooltip, withStyles } from '@material-ui/core';
import { useAdminOfferAuction } from '../hooks';
import { AdminReservePrice } from './AdminReservePrice';
import { useAdminWantsCells } from '../hooks/useAdminCounterInfo';

const Wrapper = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  font-weight: 500;
  gap: 4px;
`;

const CounterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > span {
    font-size: 13px;
    white-space: nowrap;
  }
`;

/** The counter the buyer currently sees is bolded; the rest stay at the regular weight. */
const CounterRow = styled.span<{ $bold?: boolean }>`
  font-weight: ${props => (props.$bold ? 700 : 400)};
`;

const styles = () => ({
  tooltip: {
    backgroundColor: '#ffffff',
    color: '#616161',
    fontSize: 14,
    opacity: 1,
    width: 400,
    maxWidth: '100vw',
    marginTop: 6
  },
  popper: {
    backgroundColor: '#ffffff',
    opacity: 1,
    wordBreak: 'break-word',
    boxShadow:
      '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
    top: '20px !important'
  }
});

const NotesWrapper = styled.div``;

export const AdminCounterAmount = withStyles(styles as any)(({ vehicle, classes }: any) => {
  const [notesActive, setNotesActive] = useState(false);
  const offerAuction = useAdminOfferAuction(vehicle.id);

  const openNotes = () => {
    if (!hasAtLeastOneCounter) return;
    setNotesActive(true);
  };

  const { aa, s, b, hasAtLeastOneCounter } = useAdminWantsCells(vehicle);

  const closeNotes = () => setNotesActive(false);


  return (
    <Wrapper>
      <CounterWrapper onMouseOver={openNotes} onMouseOut={closeNotes}>
        <Tooltip
          classes={{ tooltip: classes.tooltip, popper: classes.popper }}
          disableHoverListener={!hasAtLeastOneCounter}
          disableFocusListener
          disableTouchListener
          open={notesActive}
          placement="top"
          title={
            <NotesWrapper>
              <OfferHistory cutNames offerAuction={offerAuction!} />
            </NotesWrapper>
          }
        >
          <>
            <CounterRow $bold={aa.isVisibleToBuyer}>
              {aa.label} - {aa.amount}
            </CounterRow>
            <CounterRow $bold={s.isVisibleToBuyer}>
              {s.label} - {s.amount}
            </CounterRow>
            <CounterRow $bold={b.isVisibleToBuyer}>
              {b.label} - {b.amount}
            </CounterRow>
          </>
        </Tooltip>
      </CounterWrapper>
      <AdminReservePrice vehicle={vehicle} />
    </Wrapper>
  );
});
